// // NOTE: I am hardcoding the text snippet needed directly so it works stand-alone, 
// // just like your reference JSON file, but without requiring an external import. 
// const text = {
//   AppendixDialatedMesentericNodesTypeText: "{1} subcentimetric mescentric nodes in right iliac fossa. "
// };

// export function generateCtAbdomenReport(frmData, currentUser) {
//   let report = "";
//   const impression = [];
  
//   // Demographics Table Header
//   if (frmData.NameTextFR18 && frmData.IDTextFR18 && frmData.AgeTextFR18 && frmData.GenderTextFR18 && frmData.TestDateTextFR18 && frmData.ReportDateTextFR18) {
//     report += `
//       <pre><b><header><table>
//         <tr>
//           <td>Name: ${frmData.NameTextFR18}</td>
//           <td>Patient ID: ${frmData.IDTextFR18}</td>
//           <td>Age: ${frmData.AgeTextFR18}</td>
//         </tr>
//         <tr>
//           <td>Gender: ${frmData.GenderTextFR18}</td>
//           <td>Test date: ${frmData.TestDateTextFR18}</td>
//           <td>Report date: ${frmData.ReportDateTextFR18}</td>
//         </tr>
//         <tr>
//           <td>Referral Dr: ${frmData.ReferralDrTextFR18 || "N/A"}</td>
//           <td colspan="2">Report time: ${frmData.ReporttimeTextFR18 || "N/A"}</td>
//         </tr>
//       </table></header></b></pre>
//     `;
//   }

//   // Title
//   if (frmData.Appendix) {
//     report += `
//       <h5><center><strong><u>CT ABDOMEN</u></strong></center></h5>
//       <h5><strong><u>OBSERVATIONS:</u></strong></h5>
//     `;
//   }

//   // Appendix Logic
//   if (frmData.Appendix) {
    
//     // Dilated & Fat Stranding
//     if (frmData.AppendixDialated || frmData.AppendixDialatedPeriappendicealFatStranding) {
//       if (frmData.AppendixDialatedText && !frmData.AppendixDialatedPeriappendicealFatStranding) {
//         report += "<p><b>Appendix is dilated, measures " + frmData.AppendixDialatedText + " mm in diameter without peri-appendiceal fat stranding.</b></p>";
//       } else if (frmData.AppendixDialatedText && frmData.AppendixDialatedPeriappendicealFatStranding) {
//         report += "<p><b>Appendix is dilated, measures " + frmData.AppendixDialatedText + " mm in diameter with peri-appendiceal fat stranding.</b></p>";
//       }
//     }

//     // Fluid Collections
//     if (frmData.AppendixDialatedPeriappendicealFluidCollection && !frmData.AppendixDialatedPeriappendicealFluidType) {
//       report += "<p><b>Peri-appendiceal fluid collection is present.</b></p>";
//     }
    
//     if (frmData.AppendixDialatedPeriappendicealFluidType) {
//       report += "<p><b>Mild peri-appendiceal free fluid present.</b></p>";
//     }
    
//     if (frmData.AppendixDialatedPeriappendicealPeriphereally && frmData.AppendixDialatedPeriappendicealPeriphereallyText && frmData.AppendixDialatedPeriappendicealPeriphereallyText1) {
//       report += "<p><b>A peripherally enhancing localized peri-appendiceal fluid collection measuring of " + frmData.AppendixDialatedPeriappendicealPeriphereallyText + " x " + frmData.AppendixDialatedPeriappendicealPeriphereallyText1 + " cm suggestive of abscess.</b></p>";
//     }

//     // Extra Luminal Air Pockets
//     if (frmData.AppendixDialatedPeriappendiceal) {
//       report += "<p><b>Peri-appendiceal extra luminal air pockets suggestive of perforation.</b></p>";
//     }

//     // Mesenteric Nodes
//     if (frmData.AppendixDialatedMesentericNodes) {
//       let nodeStr = "";
//       if (frmData.AppendixDialatedMesentericNodesType) {
//         nodeStr += "<b>" + text.AppendixDialatedMesentericNodesTypeText.replace("{1}", frmData.AppendixDialatedMesentericNodesType);
//       }
//       if (frmData.AppendixDialatedMesentericNodesType === 'Enlarged' && frmData.AppendixDialatedMesentericNodesEnlarged) {
//         nodeStr += " Size of the largest node " + frmData.AppendixDialatedMesentericNodesEnlarged + " mm.</b>";
//       } else if (frmData.AppendixDialatedMesentericNodesType) {
//         nodeStr += "</b>";
//       }
      
//       if (nodeStr) {
//         report += "<p>" + nodeStr + "</p>";
//       }
//     }

//     // Appendicular Mass
//     if (frmData.AppendixDialatedAppendicularMass) {
//       if (frmData.AppendixDialatedAppendicularMassWithAdhesion) {
//         let massStr = "<b>There is a appendicular mass formation with adhesion to distal ileal loops and caecum";
        
//         if (frmData.AppendixDialatedAppendicularMassWithAdhesionText && frmData.AppendixDialatedAppendicularMassWithAdhesionText1) {
//           massStr += ", size measuring " + frmData.AppendixDialatedAppendicularMassWithAdhesionText + " x " + frmData.AppendixDialatedAppendicularMassWithAdhesionText1 + " cm.";
//         } else {
//           massStr += ".";
//         }
        
//         massStr += "</b>";
//         report += "<p>" + massStr + "</p>";
//       }
//     }
//   }

//   // Page Break
//   report += `<div class="page-break ck-widget ck-widget_selected" contenteditable="false" draggable="true"></div>`;

//   // Impression
//   report += `
//     <p><strong><u>IMPRESSION:</u></strong></p>
//     <p>
//       ${impression.length > 0 
//         ? impression.join("<br>") 
//         : "<strong>• Kindly correlate clinically.</strong>"
//       }
//     </p>
//   `;

//   // Signature Block
//   if (currentUser) {
//     report += `
//       <p>
//         <br>
//         <img src="${currentUser.signature}" height="75" />
//         <br>${currentUser.full_name}<br>${currentUser.designation}
//       </p>
//     `;
//   }

//   return report;
// }




const text = {
  AppendixDialatedMesentericNodesTypeText: "{1} subcentimetric mescentric nodes in right iliac fossa. "
};

export function generateCtAbdomenReport(frmData, currentUser) {
  let report = "";
  const impression = [];
  
  if (frmData.NameTextFR18 && frmData.IDTextFR18 && frmData.AgeTextFR18 && frmData.GenderTextFR18 && frmData.TestDateTextFR18 && frmData.ReportDateTextFR18) {
    report += `
      <pre><b><header><table>
        <tr>
          <td>Name: ${frmData.NameTextFR18}</td>
          <td>Patient ID: ${frmData.IDTextFR18}</td>
          <td>Age: ${frmData.AgeTextFR18}</td>
        </tr>
        <tr>
          <td>Gender: ${frmData.GenderTextFR18}</td>
          <td>Test date: ${frmData.TestDateTextFR18}</td>
          <td>Report date: ${frmData.ReportDateTextFR18}</td>
        </tr>
        <tr>
          <td>Referral Dr: ${frmData.ReferralDrTextFR18 || "N/A"}</td>
          <td colspan="2">Report time: ${frmData.ReporttimeTextFR18 || "N/A"}</td>
        </tr>
      </table></header></b></pre>
    `;
  }

  if (frmData.Appendix) {
    report += `
      <h5><center><strong><u>CT ABDOMEN</u></strong></center></h5>
      <h5><strong><u>OBSERVATIONS:</u></strong></h5>
    `;
  }

  if (frmData.Appendix) {
    if (frmData.AppendixDialated || frmData.AppendixDialatedPeriappendicealFatStranding) {
      if (frmData.AppendixDialatedText && !frmData.AppendixDialatedPeriappendicealFatStranding) {
        report += "<p><b>Appendix is dilated, measures " + frmData.AppendixDialatedText + " mm in diameter without peri-appendiceal fat stranding.</b></p>";
      } else if (frmData.AppendixDialatedText && frmData.AppendixDialatedPeriappendicealFatStranding) {
        report += "<p><b>Appendix is dilated, measures " + frmData.AppendixDialatedText + " mm in diameter with peri-appendiceal fat stranding.</b></p>";
      }
    }

    if (frmData.AppendixDialatedPeriappendicealFluidCollection && !frmData.AppendixDialatedPeriappendicealFluidType) {
      report += "<p><b>Peri-appendiceal fluid collection is present.</b></p>";
    }
    if (frmData.AppendixDialatedPeriappendicealFluidType) {
      report += "<p><b>Mild peri-appendiceal free fluid present.</b></p>";
    }
    if (frmData.AppendixDialatedPeriappendicealPeriphereally && frmData.AppendixDialatedPeriappendicealPeriphereallyText && frmData.AppendixDialatedPeriappendicealPeriphereallyText1) {
      report += "<p><b>A peripherally enhancing localized peri-appendiceal fluid collection measuring of " + frmData.AppendixDialatedPeriappendicealPeriphereallyText + " x " + frmData.AppendixDialatedPeriappendicealPeriphereallyText1 + " cm suggestive of abscess.</b></p>";
    }

    if (frmData.AppendixDialatedPeriappendiceal) {
      report += "<p><b>Peri-appendiceal extra luminal air pockets suggestive of perforation.</b></p>";
    }

    if (frmData.AppendixDialatedMesentericNodes) {
      let nodeStr = "";
      if (frmData.AppendixDialatedMesentericNodesType) {
        nodeStr += "<b>" + text.AppendixDialatedMesentericNodesTypeText.replace("{1}", frmData.AppendixDialatedMesentericNodesType);
      }
      if (frmData.AppendixDialatedMesentericNodesType === 'Enlarged' && frmData.AppendixDialatedMesentericNodesEnlarged) {
        nodeStr += " Size of the largest node " + frmData.AppendixDialatedMesentericNodesEnlarged + " mm.</b>";
      } else if (frmData.AppendixDialatedMesentericNodesType) {
        nodeStr += "</b>";
      }
      if (nodeStr) report += "<p>" + nodeStr + "</p>";
    }

    if (frmData.AppendixDialatedAppendicularMass) {
      if (frmData.AppendixDialatedAppendicularMassWithAdhesion) {
        let massStr = "<b>There is a appendicular mass formation with adhesion to distal ileal loops and caecum";
        if (frmData.AppendixDialatedAppendicularMassWithAdhesionText && frmData.AppendixDialatedAppendicularMassWithAdhesionText1) {
          massStr += ", size measuring " + frmData.AppendixDialatedAppendicularMassWithAdhesionText + " x " + frmData.AppendixDialatedAppendicularMassWithAdhesionText1 + " cm.";
        } else {
          massStr += ".";
        }
        massStr += "</b>";
        report += "<p>" + massStr + "</p>";
      }
    }
  }

  report += `<div class="page-break ck-widget ck-widget_selected" contenteditable="false" draggable="true"></div>`;

  report += `
    <p><strong><u>IMPRESSION:</u></strong></p>
    <p>
      ${impression.length > 0 ? impression.join("<br>") : "<strong>• Kindly correlate clinically.</strong>"}
    </p>
  `;

  if (currentUser) {
    report += `
      <p>
        <br>
        <img src="${currentUser.signature}" height="75" />
        <br>${currentUser.full_name}<br>${currentUser.designation}
      </p>
    `;
  }

  return report;
}